import axios from 'axios';
import querystring from 'querystring'
import router from '../router/index';
import { Message, Loading } from 'element-ui';
// import urls from '@/config/urls';
/* const BUILD_RUNTIME = process.env.BUILD_RUNTIME;
 const nodeEnv = process.env.NODE_ENV;
 const baseUrl = (BUILD_RUNTIME === 'hybird' ? (nodeEnv === 'production' ? urls.appProBaseUrl : urls.appDevBaseUrl) : '')*/
 // axios.defaults.baseURL=  urls.getBaseUrl();

let loading;
function start_loading() {
  loading = Loading.service({
    fullscreen: true,
    text: "努力加载中",
    spinner: 'el-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  });
}
function close_loading() {
  loading.close();
}


//拦截请求
axios.interceptors.request.use(function (config) {
  config.headers = Object.assign({}, config.headers || {}, {
    'accountId': localStorage.id,
    'uid':  localStorage.uid,
  })
  if (((config.method || '').toLowerCase() === 'post' || (config.method || '').toLowerCase() === 'put' ) && config.data && !config.headers['Content-Type']) {
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    config.data = querystring.stringify(config.data);
  }
  if (config.url.indexOf('?') < 0) {
    config.url += '?_=' + new Date().getTime()
  } else {
    config.url += '&_=' + new Date().getTime()
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

//拦截响应
axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  return Promise.reject(error);
});

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }
  if (response.data.status === -1) {
    sessionStorage.removeItem('token')
    window.location.replace('/')
  }
  const errortext = response.statusText;
  const error = new Error(errortext);
  error.name = response.status;
  error.response = response;
  throw error;
}


//存储正在请求中的ajax
var AJATOKEN = {}
function compileAjaxToken(option) {
  option = option || {};
  var token = option.url + option.method + JSON.stringify(option.data || option.params || {});
  return token;
}
var http = function (option, token) {

  //判断重复请求
  var donotRepeat = option.doNotRepeat === void 0 ? true : option.doNotRepeat;
  if (donotRepeat) {
    if (AJATOKEN[token]) {
      var then = {
        then: function () {
          return then;
        },
        catch: function () {

        }
      }
      return then;
    }
    AJATOKEN[token] = true;
  }
  option.headers = option.headers || {};
  option.isLoading && start_loading();
  return axios(option).then(checkStatus).then((res) => {
    option.isLoading && close_loading();
    delete AJATOKEN[token];
    if (res.data.status === '0') {
      return Promise.resolve({
        status: res.data.status,
        data: res.data.msg || {},
        fullData: res.data
      })
    } else {
      if (res.data.status === '4') {
        console.log(res.data.msg)
        Message({
          message: res.data.msg,
          type: 'error'
        });
      } else if (res.data.status === '9') {
        localStorage.removeItem('token');
        router.push('/login');
        Message({
          message: res.data.msg,
          type: 'error'
        });
      } 
      return Promise.reject({
        status: res.data.status,
        data: res.data.msg || {},
        fullData: res.data
      })
    }
  })
}

function request(option) {
  option = option || {};
  var token = compileAjaxToken(option);
  var promise = http(option, token);
  setTimeout(() => {
    promise.catch((error) => {
      option.isLoading && close_loading();
      delete AJATOKEN[token];
      if (error.status === void 0) {
        Message({
          message: "网络出现故障了，请稍后再试",
          type: 'error'
        });
      }
      return {}
    })
  })
  return promise;
}

const installer = {
  vm: {},
  install (Vue) {
    Vue.prototype.$post = function (url, data = {}) {
      return request({
        method: 'post',
        url: url, // 请求域
        data: data// 参数
      })
    }
  }
}




export {
  request,
  installer as VueAxios,
};



// WEBPACK FOOTER //
// ./src/utils/request.js